import { Model } from '@kaiser-software/chassis-core';
import { CategoryModel } from '../../observations/models/category.model';

export class KpiModel extends Model {

    public createdAt: string;

    public updatedAt: string;

    public observation_category_id: number;

    public category: CategoryModel;

    // public category(): CategoryModel {
    //     return this.hasOne(CategoryModel, 'category');
    // }

}



// WEBPACK FOOTER //
// ./apps/eyewatch/src/app/eyewatch/kpis/models/kpi.model.ts